import { BaseWebComponentDataProviderFactory } from '../../../../framework/BaseWebComponentDataProviderFactory';
import { CompanyDetailsTabGzDataProvider } from '../dataProvider/CompanyDetailsTabGzDataProvider';
import { API_TYPE_GZ } from '../../../../webcomponents.constants';

export class CompanyDetailsTabDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, CompanyDetailsTabGzDataProvider);
  }
}
